import styles from '../MatchControl.module.scss';

import MatchControlButton from './MatchControlButton';
import MatchControlIcon from './MatchControlIcon';

type ExtraInProps = {
  isRunning?: boolean;
  disabled?: boolean;
  handleChangeExtraTime: (amount: number) => void;
  handleToggleIsExtraTimeLive: () => void;
};

const ExtraIn = ({
  isRunning = false,
  disabled = false,
  handleChangeExtraTime,
  handleToggleIsExtraTimeLive,
}: ExtraInProps) => {
  const handleAddExtraTime = (amount: number) => {
    handleChangeExtraTime(amount);
  };

  const handleSubtractExtraTime = (amount: number) => {
    handleChangeExtraTime(-amount);
  };

  return (
    <div className={styles.ExtraInWrapper}>
      <div className={styles.ActionsWrapper}>
        <MatchControlButton
          variant="icon"
          onClick={() => handleSubtractExtraTime(1000)}
          disabled={disabled}
        >
          <MatchControlIcon iconProps={{ icon: 'minus' }} />
        </MatchControlButton>
        <MatchControlButton
          variant="icon"
          onClick={() => handleAddExtraTime(1000)}
          disabled={disabled}
        >
          <MatchControlIcon iconProps={{ icon: 'plus' }} />
        </MatchControlButton>
      </div>
      <MatchControlButton
        isRunning={isRunning}
        onClick={handleToggleIsExtraTimeLive}
        disabled={disabled}
      >
        EXTRA
      </MatchControlButton>
    </div>
  );
};

export default ExtraIn;
